import { render } from "./UserProfilePicker.vue?vue&type=template&id=66cce590&scoped=true&ts=true"
import script from "./UserProfilePicker.ts?vue&type=script&lang=ts"
export * from "./UserProfilePicker.ts?vue&type=script&lang=ts"

import "./UserProfilePicker.scss?vue&type=style&index=0&id=66cce590&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66cce590"]])

export default __exports__